$(function() {
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'load_events',
            url: myajax,
            catId: 'all',
            paged: 1,
        };

    function loadPosts(paramObj) {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            beforeSend() {
                $('.js-ajax-events').css({
                    'opacity': '.3',
                    'pointer-events': 'none'
                });
            },
            success(data) {
                $('.js-ajax-events').html(data);
            },
            complete() {
                $('.js-ajax-events').css({
                    'opacity': '1',
                    'pointer-events': 'auto'
                });
            }
        });
    }

    $('body').on('click', '.js-load-event', function(e) {
        e.preventDefault();

        let $this = $(this),
            catID = $this.data('cat-id'),
            href = $this.attr('href');

        if (!$this.hasClass('is-active')) {
            $('.js-load-event').removeClass('is-active');
            $this.addClass('is-active');
        }

        paramObj.catId = catID ? catID : 'all';
        paramObj.paged = 1;

        window.history.pushState({}, '', href);

        loadPosts(paramObj);
    });
});